const isIOS = () => {
  return (
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) ||
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    )
  );
};

export default isIOS;
